import { GameStatus } from "../../models/GameStatus";
import store from "../../store/store";
import "./Table.scss";
import TableHidden from "./TableHidden";
import TableResults from "./TableResults";
import TableRevealed from "./TableRevealed";

export default function Table() {
  const gameState = store.getState().game;

  const isVoting = gameState.status === GameStatus.VOTE;
  const isResults = gameState.status === GameStatus.TURN_RESULTS;

  let content = <TableHidden />;

  if (isVoting) {
    content = <TableRevealed />;
  }
  else if (isResults) {
    content = <TableResults />;
  }

  return (
    <>
        {content}
    </>
  );
}
